// src/components/Header.js
import React from 'react';

const Header = () => {
  return (
    <header>
        <div className="text-white mb-8">
            <h1 className="text-3xl font-bold">Neil Panchal</h1>
            <p className="text-sm">AI Engineer</p>
        </div>
        
    </header>
  );
};

export default Header;
